<style lang="scss">
  @use "../../assets/css/design-system/colors";
  @use "../../assets/css/design-system/mixins";
  @use "../../assets/css/design-system/utils";

  div {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: utils.in_rem(4px);

    .bounds {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      color: colors.get(textGrey);
      @include mixins.caption();
    }
  }

  .slider-input {
    width: 100%;
    height: utils.in_rem(20px);
    padding: 0;
    background-color: transparent;
    -webkit-appearance: none;
    appearance: none;

    &::-webkit-slider-thumb {
      width: utils.in_rem(20px);
      height: utils.in_rem(20px);
      margin-top: utils.in_rem(-4px);
      background-color: colors.get(primary_50);
      border: 0;
      border-radius: 20px;
      -webkit-appearance: none;
      appearance: none;
    }

    @mixin slider-track-background($active-color) {
      background: linear-gradient(
        to right,
        $active-color calc(var(--midFraction) * 100% - var(--activeTrackOffset)),
        transparent calc(var(--midFraction) * 100% - var(--activeTrackOffset)),
        transparent calc(var(--midFraction) * 100% + var(--inactiveTrackOffset)),
        colors.get(interfaceSwGrey_10)
          calc(var(--midFraction) * 100% + var(--inactiveTrackOffset))
      );
    }

    &::-webkit-slider-runnable-track {
      width: 100%;
      height: utils.in_rem(12px);
      color: transparent;
      border-radius: 16px;
      border-color: transparent;
      cursor: pointer;
      @include slider-track-background(colors.get(primary_50));
    }

    &:hover {
      &::-webkit-slider-thumb {
        background-color: colors.get(primary_60);
        border: 0;
      }
      &::-webkit-slider-runnable-track {
        @include slider-track-background(colors.get(primary_60));
      }
    }

    &:focus {
      outline: 0;
      &::-webkit-slider-thumb {
        background-color: colors.get(primary_60);
        border: 2px solid colors.get(primary_40);
      }
      &::-webkit-slider-runnable-track {
        @include slider-track-background(colors.get(primary_60));
      }
    }

    &:active {
      &::-webkit-slider-thumb {
        background-color: colors.get(primary_70);
        border: 0;
      }
      &::-webkit-slider-runnable-track {
        @include slider-track-background(colors.get(primary_70));
      }
    }

    &:disabled {
      &::-webkit-slider-thumb {
        background-color: colors.get(interfaceDisabledGrey_10);
        border: 0;
      }
      &::-webkit-slider-runnable-track {
        cursor: default;
        @include slider-track-background(colors.get(interfaceDisabledGrey_10));
      }
    }
  }
</style>

<script>
  export let min = 0;
  export let max; // Maximum has to be set by the parent component
  export let step = 1;
  export let value = 0;
  export let disabled = false;

  $: {
    if (value < min) value = min;
    if (value > max) value = max;
  }

  const handleChange = (event) => {
    value = Number(event.target.value);
  };

  // Dynamically calculate there active track should end and inactive start
  $: midFraction = (value - min) / (max - min);
  $: activeTrackOffset = `${2 + midFraction * 20}px`;
  $: inactiveTrackOffset = `${2 + (1 - midFraction) * 20}px`;
</script>

<div>
  <input
    class="slider-input"
    class:disabled
    type="range"
    {min}
    {max}
    {step}
    {disabled}
    bind:value
    on:input={handleChange}
    style="--midFraction: {midFraction}; --activeTrackOffset: {activeTrackOffset}; --inactiveTrackOffset: {inactiveTrackOffset}"
  />
  <div class="bounds">
    <span>{min}</span>
    <span>{max}</span>
  </div>
</div>
